import isEqual from "lodash.isequal";

import { FullFormAction } from "../../../../Engine/Core/Store/FullFormAction";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import {
    setHiddenColgroupingGroupState,
    setIsLoading,
    updateColumnGroupingGroupStates,
    updateHiddenColgroupingGroupFilledCount,
} from "../../../../Helpers/StateAccessors/ColgroupHelpers";

import { CrossFitTableActionType } from "./crossFitTableActions";

function increment(val: number): number {
    return val + 1;
}

function decrement(val: number): number {
    return val > 0 ? val - 1 : 0;
}

export function crossFitTableReducer(state: FullFormState, action: FullFormAction): FullFormState {
    switch (action.type) {
        case CrossFitTableActionType.SetColumnGrouping: {
            const { stickyTablePath, groupKey, isShowColumns } = action.payload;

            return updateColumnGroupingGroupStates(
                state,
                stickyTablePath,
                groupKey,
                isShowColumns ? increment : decrement,
                0
            );
        }
        case CrossFitTableActionType.SetHiddenColumnGrouping: {
            const { stickyTablePath, groupKey, isShowColumns } = action.payload;

            return updateHiddenColgroupingGroupFilledCount(
                state,
                stickyTablePath,
                groupKey,
                isShowColumns ? increment : decrement,
                0
            );
        }
        case CrossFitTableActionType.SetStateHiddenColumnGrouping: {
            const { stickyTablePath, groupKey, isShowColumns } = action.payload;

            return setHiddenColgroupingGroupState(state, stickyTablePath, groupKey, isShowColumns ? "show" : "hide");
        }
        case CrossFitTableActionType.ColumnGroupingBatch: {
            let nextState = state;
            for (const batchItem of action.payload.events) {
                nextState = crossFitTableReducer(nextState, batchItem);
            }
            if (isEqual(nextState, state)) {
                return state;
            }
            return nextState;
        }
        case CrossFitTableActionType.SetLoading: {
            const { stickyTablePath, loading } = action.payload;

            return setIsLoading(state, stickyTablePath, loading);
        }
        default:
            return state;
    }
}
